export const localizeDate = (date: string) => {
  if (date === '') return null; // Return null if date is empty

  // Step 1: Create a local date object with the given date and time (00:00:00)
  const localDateStart = new Date(`${date}T00:00:00`);

  // Step 2: Convert the local time to UTC
  const localDateStartUTC = new Date(
    localDateStart.getTime() + localDateStart.getTimezoneOffset() * 60000
  );

  // Step 3: Format the UTC date as an ISO string
  const localDateStartUTCString = localDateStartUTC.toISOString();

  // Step 1: Create a local date object with the given date and time (23:59:59)
  const localDateEnd = new Date(`${date}T23:59:59`);

  // Step 2: Convert the local time to UTC
  const localDateEndUTC = new Date(
    localDateEnd.getTime() + localDateEnd.getTimezoneOffset() * 60000
  );

  // Step 3: Format the UTC date as an ISO string
  const localDateEndUTCString = localDateEndUTC.toISOString();

  return { start: localDateStartUTCString, end: localDateEndUTCString };
};
